export const SOURCE_CENTRIC_SECTION_IDS = [
  'vitals',
  'family-members',
  'other-relationships',
  'other-information',
] as const

export type VisibleSectionId = (typeof SOURCE_CENTRIC_SECTION_IDS)[number]
